(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('markdown-it-container/dist/markdown-it-container.min'), require('react'), require('react-dom'), require('react-dom/server'), require('babel-standalone/babel.min')) :
  typeof define === 'function' && define.amd ? define(['exports', 'markdown-it-container/dist/markdown-it-container.min', 'react', 'react-dom', 'react-dom/server', 'babel-standalone/babel.min'], factory) :
  (global = global || self, factory(global.replacer = {}, global.container, global.React, global.ReactDOM, global.ReactDOMServer, global.babel));
}(this, function (exports, container, React, ReactDOM, ReactDOMServer, babel) { 'use strict';

  container = container && container.hasOwnProperty('default') ? container['default'] : container;
  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
  ReactDOMServer = ReactDOMServer && ReactDOMServer.hasOwnProperty('default') ? ReactDOMServer['default'] : ReactDOMServer;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var babelTransformOptions = {
    presets: ['stage-3', 'react', 'es2015'],
    plugins: ['filterXSS']
  };
  var attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
  var unquoted = '[^"\'=<>`\\x00-\\x20]+';
  var single_quoted = '\'[^\']*\'';
  var double_quoted = '"[^"]*"';
  var attr_value = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';
  var attribute = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';
  var open_tag = '<[A-Z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/>'; // var close_tag   = '<\\/[A-Z][A-Za-z0-9\\-]*\\s*>';

  var REACT_TAG_RE = new RegExp('^(?:' + open_tag + ')');
  var REACT_OPEN_CLOSE_TAG_RE = /^<([A-Z][A-Za-z0-9]*)(?:.|[\n\f\r\t\v])*?<\/\1>/;

  function filterXSS() {
    return {
      visitor: {
        Identifier: function Identifier(path) {
          if (path.isIdentifier({
            name: 'constructor'
          })) {
            console.warn('constructor xss'); // path.node.name = 'x';
          } // else if (typeof window !== 'undefined' && window[path.node.name]) {
          //   path.node.name = 'x';
          // }

        },
        // Function traverse
        FunctionExpression: function FunctionExpression(path) {
          path.traverse({
            ThisExpression: function ThisExpression() {
              console.warn('this escape xss attack'); // path.remove();
            }
          });
        },
        FunctionDeclaration: function FunctionDeclaration(path) {
          var funcName = path.node.id.name;

          if (funcName !== 'YMGGKLK') {
            path.traverse({
              ThisExpression: function ThisExpression() {
                console.warn('this escape xss attack'); // path.remove();
              }
            });
          }
        },
        // ThisExpression() {
        // console.log('this');
        // },
        JSXIdentifier: function JSXIdentifier(path) {
          if (path.node.name === 'dangerouslySetInnerHTML') {
            console.warn('dangerouslySetInnerHTML xss'); // path.node.name = 'sanitizition';
          }
        },
        MemberExpression: function MemberExpression(path) {
          if (path.node.computed) {
            var string = ' ';
            path.traverse({
              StringLiteral: function StringLiteral(path) {
                string += path.node.value;
              }
            });

            if (string.includes('constructor')) {
              console.warn('constructor str xss');
              path.remove();
            }
          }
        }
      }
    };
  } // compile javascript code with sandbox

  function compileCode(code) {
    code = 'with (sandbox) {' + code + '}';
    var fn = new Function('sandbox', code);
    return function (sandbox) {
      var proxy = new Proxy(sandbox, {
        has: function has() {
          return true; // cheet prop
        },
        get: function get(target, key, receiver) {
          // protect escape
          if (key === Symbol.unscopables) {
            return undefined;
          }

          return Reflect.get(target, key, receiver);
        }
      });
      return fn(proxy);
    };
  } // render react code to dom

  function renderReact(wrapperId, reactCode, sandbox) {
    if (typeof window === 'undefined' || !document) {
      return;
    }

    var __document = document;

    if (this && this.document) {
      __document = this.document;
    }

    var __container = __document.getElementById(wrapperId);

    if (!__container) {
      return;
    }

    var newSandbox = _objectSpread2({}, sandbox, {
      __container: __container
    });

    var func = compileCode(reactCode);
    func(newSandbox); // style resume

    __container.style.opacity = 1;
  }
  function getWrapperId() {
    return 'rc' + Math.random().toString(36).substr(2, 10);
  }

  var NOOP = function NOOP() {};

  var Replacer =
  /*#__PURE__*/
  function () {
    function Replacer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Replacer);

      if (options.sandbox && _typeof(options.sandbox) !== 'object') {
        throw Error('sandbox must be object!');
      }

      if (options.babelInit && typeof options.babelInit !== 'function') {
        throw Error('babelInit must be function!');
      }

      this._init(options);
    }

    _createClass(Replacer, [{
      key: "_init",
      value: function _init(_ref) {
        var _ref$babelInit = _ref.babelInit,
            babelInit = _ref$babelInit === void 0 ? NOOP : _ref$babelInit,
            _ref$sandbox = _ref.sandbox,
            sandbox = _ref$sandbox === void 0 ? {} : _ref$sandbox,
            babelOptions = _ref.babelOptions,
            _ref$enableSSR = _ref.enableSSR,
            enableSSR = _ref$enableSSR === void 0 ? true : _ref$enableSSR;

        if (!babel.availablePlugins.filterXSS) {
          babel.registerPlugin('filterXSS', filterXSS);
        }

        babelInit(babel);
        this.babel = babel;
        this.babelOptions = _objectSpread2({}, babelTransformOptions, {}, babelOptions);
        this.sandbox = _objectSpread2({
          React: React,
          ReactDOM: ReactDOM,
          NULL: Object.create(null),
          ReactDOMServer: ReactDOMServer
        }, sandbox);
        this.enableSSR = enableSSR;
        this.env = {};
      }
    }, {
      key: "_replace",
      value: function _replace(_ref2) {
        var str = _ref2.str,
            wrapperId = _ref2.wrapperId,
            lang = _ref2.lang;

        if (lang === 'mixin-react') {
          return this._replacerReact(str, wrapperId);
        }

        return str;
      } // get html of react code

    }, {
      key: "_replacerReact",
      value: function _replacerReact(code, wrapperId) {
        var reactCode = "function YMGGKLK(props) { ".concat(code, " }\n                  ReactDOM.hydrate(YMGGKLK.call(NULL),__container)\n                  ");

        var finalCode = this._transReactCode(reactCode);

        var html = this.enableSSR ? this._codeToHtml(wrapperId, code) : '<div></div>';
        setTimeout(renderReact.bind(this.env, wrapperId, finalCode, this.sandbox), 0);
        return html;
      } // pre-render HTML

    }, {
      key: "_codeToHtml",
      value: function _codeToHtml(wrapperId, code) {
        var reactCode = "function YMGGKLK(props) { ".concat(code, " }\n                  Html[\"").concat(wrapperId, "\"] = ReactDOMServer.renderToStaticMarkup(YMGGKLK.call(NULL))\n                  ");
        var Html = {};

        var newSandbox = _objectSpread2({}, this.sandbox, {
          Html: Html
        });

        var func = compileCode(this._transReactCode(reactCode));
        func(newSandbox);
        return Html[wrapperId];
      } // use babel translation react code

    }, {
      key: "_transReactCode",
      value: function _transReactCode(code) {
        var rst = this.babel.transform(code, this.babelOptions);
        return rst.code;
      }
    }, {
      key: "getHtml",
      value: function getHtml(wrapperId, str) {
        var env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'mixin-react';
        this.env = env;

        var html = this._replace({
          str: str,
          wrapperId: wrapperId,
          lang: lang
        });

        return html;
      }
    }]);

    return Replacer;
  }();

  // React block
  var REACT_SEQUENCES = [// PascalCase Components
  [REACT_TAG_RE, /^$/, true], [/^<([A-Z][A-Za-z0-9]*)/, /^$/, true, function (p1) {
    return new RegExp("<?/(".concat(p1, ")?>\\s*$"));
  }] // [ /^<![A-Z]/,     />/,     true ],
  // [ new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true ],
  // [ new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),  /^$/, false ]
  ];
  var htmlReg = /<[a-z]+.*>/;
  function react_block(state, startLine, endLine, silent) {
    var i,
        nextLine,
        token,
        lineText,
        pos = state.bMarks[startLine] + state.tShift[startLine],
        max = state.eMarks[startLine],
        match = ''; // if it's indented more than 3 spaces, it should be a code block

    if (state.sCount[startLine] - state.blkIndent >= 4) {
      return false;
    }

    if (!state.md.options.html) {
      return false;
    }

    if (state.src.charCodeAt(pos) !== 0x3C
    /* < */
    ) {
        return false;
      }

    lineText = state.src.slice(pos, max);

    for (i = 0; i < REACT_SEQUENCES.length; i++) {
      if (REACT_SEQUENCES[i][0].test(lineText)) {
        match = lineText.match(REACT_SEQUENCES[i][0])[1];
        break;
      }
    }

    if (i === REACT_SEQUENCES.length) {
      return false;
    }

    if (silent) {
      // true if this sequence can be a terminator, false otherwise
      return REACT_SEQUENCES[i][2];
    }

    nextLine = startLine + 1;

    if (typeof REACT_SEQUENCES[i][3] === 'function') {
      REACT_SEQUENCES[i][1] = REACT_SEQUENCES[i][3](match);
    } // If we are here - we detected HTML block.
    // Let's roll down till block end.


    if (!REACT_SEQUENCES[i][1].test(lineText)) {
      for (; nextLine < endLine; nextLine++) {
        if (state.sCount[nextLine] < state.blkIndent) {
          break;
        }

        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);

        if (REACT_SEQUENCES[i][1].test(lineText) && !htmlReg.test(lineText)) {
          if (lineText.length !== 0) {
            nextLine++;
          }

          break;
        }
      }
    }

    state.line = nextLine;
    token = state.push('react_block', '', 0);
    token.map = [startLine, nextLine];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
  }

  function isLetter(ch) {
    /*eslint no-bitwise:0*/
    var lc = ch | 0x20; // to lower case

    return lc >= 0x61
    /* a */
    && lc <= 0x7a
    /* z */
    ;
  }

  function isFailedSecondCh(ch) {
    return ch !== 0x21
    /* ! */
    && ch !== 0x3F
    /* ? */
    && ch !== 0x2F
    /* / */
    && !isLetter(ch);
  }

  function react_inline(state, silent) {
    var pos = state.pos;

    if (!state.md.options.html) {
      return false;
    }

    function isStart() {
      return state.src.charCodeAt(pos) === 0x3C
      /* < */
      && pos + 2 < state.posMax;
    } // Check start


    if (!isStart()) {
      return false;
    } // Quick fail on second char


    if (isFailedSecondCh(state.src.charCodeAt(pos + 1))) {
      return false;
    }

    var match = state.src.slice(pos).match(REACT_OPEN_CLOSE_TAG_RE) || state.src.slice(pos).match(REACT_TAG_RE);

    if (!match) {
      return false;
    }

    if (!silent) {
      var token = state.push('react_inline', '', 0);
      token.content = state.src.slice(pos, pos + match[0].length);
    }

    state.pos += match[0].length;
    return true;
  }

  function renderSimpleComponent(replacer, content, env) {
    var wrapperId = getWrapperId();

    if (env && _typeof(env) === 'object') {
      replacer.sandbox = _objectSpread2({}, replacer.sandbox, {}, env);
    }

    var code = "return (".concat(content, ")");

    try {
      return "<span style=\"opacity: 0\" id=\"".concat(wrapperId, "\">").concat(replacer.getHtml(wrapperId, code, env), "</span>");
    } catch (e) {
      console.error(e);
      return "<span style=\"opacity: 0\" id=\"".concat(wrapperId, "\"></span>");
    }
  }
  var SupportReactComponent = function SupportReactComponent(md, options) {
    md.use.apply(md, _toConsumableArray(createContainer('rc', options, '`')));
    md.use.apply(md, _toConsumableArray(createContainer('mixin-react', options, '`')));
    var replacer = new Replacer(options);
    md['md-it-rc-replacer'] = replacer; // // react_block

    md.block.ruler.before('html_block', 'react_block', react_block, ['paragraph', 'reference', 'blockquote']);

    md.renderer.rules.react_block = function (tokens, idx, options, env) {
      return renderSimpleComponent(replacer, tokens[idx].content, env);
    }; // // react_inline


    md.inline.ruler.before('html_inline', 'react_inline', react_inline);

    md.renderer.rules.react_inline = function (tokens, idx, options, env) {
      return renderSimpleComponent(replacer, tokens[idx].content, env);
    };

    function createContainer(klass, options) {
      var marker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ':';
      return [container, klass, {
        render: function render(tokens, idx, _options, env) {
          var token = tokens[idx]; // const info = token.info.trim().slice(klass.length).trim();

          if (token.nesting === 1) {
            if (env && _typeof(env) === 'object') {
              replacer.sandbox = _objectSpread2({}, replacer.sandbox, {}, env);
            }

            var wrapperId = getWrapperId();

            try {
              var offset = tokens.slice(idx).findIndex(function (token) {
                return token.type === "container_".concat(klass, "_close");
              });
              var str = tokens.slice(idx, idx + offset).reduce(function (pre, cur) {
                var str = pre + '\n' + cur.content; // reset token

                cur.content = '';
                cur.children = [];
                return str;
              }, '');
              var html = replacer.getHtml(wrapperId, str, env);
              return "<div class=\"".concat(klass, "\" style=\"opacity: 0\" id=\"").concat(wrapperId, "\">").concat(html);
            } catch (e) {
              if (options && options.allowErrorLog) console.log(e);
              return "<div class=\"".concat(klass, "\" style=\"opacity: 0\" id=\"").concat(wrapperId, "\">");
            }
          } else {
            return '</div>\n';
          }
        },
        marker: marker
      }];
    }
  };

  exports.SupportReactComponent = SupportReactComponent;
  exports.renderSimpleComponent = renderSimpleComponent;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
